export const isEmail = async (value: string) => {
  const emailRegex = /^(\w+[\+\.-]?)*@\w+([\.-]?\w+)*(\.\w{2,9})+$/
  return !emailRegex.test(value)
    ? 'The field Email has an incorrect value. Format: [aaa]@[aaa].[aaa]'
    : ''
}

export const isHpEmail = async (value: string) => {
  const emailRegex = /^(\w+[\+\.-]?)*@hp\.com$/
  return !emailRegex.test(value)
    ? 'The field Email has an incorrect value. Format: [aaa]@[hp].[com]'
    : ''
}

export const isPhone = async (value: string) => {
  const withoutOtherCharacters = value.replace('+', '').replace(/\s/g, '')
  if (withoutOtherCharacters.length < 11) {
    return 'The field Number has an incorrect value'
  }
  return ''
}

export const isPhoneE164Format = async (value: string) => {
  return value.match(/^\+[1-9]\d{6,14}$/g)
    ? ''
    : `Must contain '+' as first symbol. Must contain 7-15 digits. Leading digit cannot be '0'. Example: +12345678`
}
